module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-4-photo-4-3174a5a796b45f1941ee6f927d395303.webp";